import { isCommunioShellBuild } from '@/config/brand';
import { isOpsItsmBuild } from '@/platform/servicedesk/isOpsItsmBuild';

/**
 * Gate for first-run nav tour + Account settings replay.
 * Shared by NavTourCoach and ProductTourReplaySettings (same product surface).
 */
export function isNavTourEnabledBuild(): boolean {
  if (process.env.NEXT_PUBLIC_TOUR_BUILD === 'true') return false;
  if (isOpsItsmBuild()) return false;
  return isCommunioShellBuild() && process.env.NEXT_PUBLIC_COMMUNIO_PRODUCT === 'true';
}
